const NON_SPACE_CHARACTER = /\S/;

export const countLeadingTrailingSpace = (
  str: string
): { leadingSpace: number; trailingSpace: number; isAllSpace: boolean } => {
  const leadingSpaceCount = str.search(NON_SPACE_CHARACTER);
  if (leadingSpaceCount === -1) {
    // All are spaces
    return {
      leadingSpace: str.length,
      trailingSpace: 0,
      isAllSpace: true,
    };
  }
  const noLeadingSpaceStr = str.slice(leadingSpaceCount);
  const trailingSpaceCount = noLeadingSpaceStr.length - noLeadingSpaceStr.trim().length;

  return {
    leadingSpace: leadingSpaceCount,
    trailingSpace: trailingSpaceCount,
    isAllSpace: false,
  };
};
